module.exports = __webpack_public_path__ + "img/ql_logo.1e8873ae.png";